import './utils/googleTranslateFix';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PostHogProviderContainer from './components/posthog/PostHogProvider';
import ErrorBoundary from './components/common/ErrorBoundary';
// import PostHogConfirmation from './components/posthog/PostHogConfirmation';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <PostHogProviderContainer>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
    {/* <PostHogConfirmation /> */}
  </PostHogProviderContainer>
);
